import { render, staticRenderFns } from "./VideoFaqs.vue?vue&type=template&id=8ff27f3c&scoped=true"
import script from "./VideoFaqs.vue?vue&type=script&lang=js"
export * from "./VideoFaqs.vue?vue&type=script&lang=js"
import style0 from "./VideoFaqs.vue?vue&type=style&index=0&id=8ff27f3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff27f3c",
  null
  
)

export default component.exports